import React, { useCallback } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';
import AutoExpandTextarea from '../../AutoExpandTextarea';

interface MessageInputProps {
  messageText: string;
  onMessageTextChange: (text: string) => void;
  onSend: () => Promise<void>;
  sending: boolean;
  disabled?: boolean;
}

export function MessageInput({
  messageText,
  onMessageTextChange,
  onSend,
  sending,
  disabled = false,
}: MessageInputProps) {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        if (!sending && messageText.trim() && !disabled) {
          onSend();
        }
      }
    },
    [messageText, sending, disabled, onSend]
  );

  return (
    <div className="p-4 border-t space-y-2">
      <AutoExpandTextarea
        placeholder="Type a message... (Cmd/Ctrl+Enter to send)"
        value={messageText}
        onChange={onMessageTextChange}
        onKeyDown={handleKeyDown}
        minRows={1}
        disabled={sending || disabled}
      />
      <div className="flex justify-end">
        <Button onClick={onSend} disabled={!messageText.trim() || sending || disabled} size="sm">
          {sending ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Sending...
            </>
          ) : (
            <>
              <Send className="mr-2 h-4 w-4" />
              Send
            </>
          )}
        </Button>
      </div>
    </div>
  );
}








